//
//
//
//
//
//
//
//

export default {
  name:'resultImg',
  data() {
    return {
      imgList:[
        {icon:'https://static.soyoung.com/sy-pre/icon_zero-1596424200774.png',textImg:'https://static.soyoung.com/sy-pre/zero-1596424200774.png'},
        {icon:'https://static.soyoung.com/sy-pre/icon_one-1596424200774.png',textImg:'https://static.soyoung.com/sy-pre/one-1596424200774.png'},
        {icon:'https://static.soyoung.com/sy-pre/icon_two-1596424200774.png',textImg:'https://static.soyoung.com/sy-pre/two-1596424200774.png'},
        {icon:'https://static.soyoung.com/sy-pre/icon_three-1596424200774.png',textImg:'https://static.soyoung.com/sy-pre/three-1596424200774.png'},
      ],
      resultImg:{}
    }
  },
  props: {
    no:{
      type:String,
      default(){ return "0" }
    }
  },
  created() {
    this.resultImg = this.imgList[this.no]
  }
}
